import qs from "qs";

import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getChargebacksList({ page, sortBy, filters, merchantId }) {
	const body = {
		page_index: page,
		page_size: PAGE_SIZE,
		sort_type: sortBy?.id || undefined,
		ascending: sortBy?.id ? sortBy?.desc : undefined,
		report_date_from: convertDateToISO(filters?.report_date?.[0]),
		report_date_to: convertDateToISO(filters?.report_date?.[1], {
			addTime: TIME_OFFSET_DAY_END,
		}),
		auth_date_from: convertDateToISO(filters?.auth_date?.[0]),
		auth_date_to: convertDateToISO(filters?.auth_date?.[1], {
			addTime: TIME_OFFSET_DAY_END,
		}),

		amount: filters?.amount,
	};

	const options = {
		method: "GET",
		params: { ...body },
		url: `${API_URL}/api/merchants/${merchantId}/chargebacks`,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

export const merchantChargebacksService = {
	getChargebacksList,
};
